import type { BaseUrl, ProjectId } from '@atlassian/jira-shared-types';

export const getUrl = (baseUrl: BaseUrl, projectId: ProjectId, organizationId: number) =>
	`${baseUrl}/rest/servicedesk/1/servicedesk/${projectId}/organisation/${organizationId}/dissasociate`;
